<template>
    <div class="content">
        <div class="top-box">
            <img class="bg" :src="require(`@/assets/theme/${theme}/status/23checkupDesc/01bg.svg`)">
            <div class="banner" :class="{'hidden' : shareTag}">
                <van-row>
                    <van-col span="6" @click="back"><img class="back-icon"
                                                         :src="require(`@/assets/theme/${theme}/status/01dailyActive/01back.svg`)">
                    </van-col>
                    <van-col span="12">
                        <div class="banner-title">{{ $t('checkupDesc.title') }}</div>
                    </van-col>
                    <van-col span="6">
                        <img @click="share" class="back-icon share-icon"
                             :src="require(`@/assets/theme/${theme}/status/23checkupDesc/02share.svg`)">
                    </van-col>
                </van-row>
            </div>
            <div class="device">{{ $t('checkupDesc.device') }}: {{ checkup.watchName }}</div>
            <div class="check-time">{{ $t('checkupDesc.checkupTime') }}: {{ checkup.checkupTime }}</div>
            <div class="top-con-box">
                <div class="top-con-title">
                    {{ $t('checkupDesc.conclusion0') }}{{ checkup.success }}{{ $t('checkupDesc.conclusion1') }}
                </div>
                <div class="top-con-sub">
                    <span class="sub-normal">{{ checkup.normalCount }}{{
                            $t('checkupDesc.term')
                        }} </span>{{ $t('checkupDesc.normal') }} <span v-if="checkup.errorCount != 0">|  <span
                    class="error">{{ checkup.errorCount }}{{
                        $t('checkupDesc.term')
                    }} </span> {{ $t('checkupDesc.error') }}</span>
                </div>
                <div class="top-con-error" v-if="checkup.isBosError">
                    <img src="@/assets/theme/light/status/23checkupDesc/11error.svg">
                    <div class="top-con-error-desc">
                        {{ $t('checkupDesc.bos') }}: {{ checkup.bos }}% {{ getBosLevel(checkup.bos) }}
                    </div>
                </div>
                <div class="top-con-error" v-if="checkup.isTemperatureError">
                    <img src="@/assets/theme/light/status/23checkupDesc/11error.svg">
                    <div class="top-con-error-desc">
                        {{ $t('checkupDesc.temperature') }}: {{ $t('checkupDesc.temperatureError') }}℃
                    </div>
                </div>
                <div class="top-con-error" v-if="checkup.isEcgError">
                    <img src="@/assets/theme/light/status/23checkupDesc/11error.svg">
                    <div class="top-con-error-desc">
                        {{ $t('checkupDesc.ecg') }}: {{ getConclude(checkup.ecgData.conclusion) }}
                    </div>
                </div>
                <div class="top-con-split"></div>
            </div>
        </div>
        <img class="ai-img" v-if="!checkup.aiAnalysis&&$i18n.locale === 'zh'" @click="toAI"
             src="@/assets/theme/light/status/23checkupDesc/03ai.png">
        <img class="ai-img" v-if="!checkup.aiAnalysis&&$i18n.locale === 'en'" @click="toAI"
             src="@/assets/theme/light/status/23checkupDesc/03aiEn.png">
        <img class="ai-img" v-if="!checkup.aiAnalysis&&$i18n.locale === 'ja'" @click="toAI"
             src="@/assets/theme/light/status/23checkupDesc/03aiJa.png">

        <div class="term-item" v-if="checkup.aiAnalysis">
            <div class="term-item-top">
                <div class="term-item-top-left">
                    <img class="term-icon" src="@/assets/theme/light/status/24deepSeek/01icon.svg">
                    DeepSeek
                </div>
                <div class="term-item-top-right"> {{ $t('deepSeek.relief') }}</div>
            </div>
            <div class="ai-box">
                <VueMarkdown :source="checkup.aiAnalysis"/>
            </div>
        </div>
        <div class="term-title">{{ $t('checkupDesc.termTitle') }}</div>
        <div class="term-item">
            <div class="term-item-top">
                <div class="term-item-top-left">
                    <img class="term-icon" src="@/assets/theme/light/status/23checkupDesc/04hr.svg">
                    {{ $t('checkupDesc.hr') }}
                </div>
                <div class="term-item-top-right"> {{ $t('checkupDesc.hrRefer') }}</div>
            </div>
            <div class="term-value">
                {{ checkup.hr ? checkup.hr : '--' }}<span class="value-unit">{{ $t('checkupDesc.hrUnit') }}</span>
            </div>
            <div class="term-desc">{{ $t('checkupDesc.hrDesc') }}</div>
        </div>
        <div class="term-item">
            <div class="term-item-top">
                <div class="term-item-top-left">
                    <img class="term-icon" src="@/assets/theme/light/status/23checkupDesc/05bos.svg">
                    <span class="term-item-title">{{ $t('checkupDesc.bos') }}</span>
                    <img v-if="checkup.isBosError" src="@/assets/theme/light/status/23checkupDesc/11error.svg">
                </div>
                <div class="term-item-top-right"> {{ $t('checkupDesc.bosRefer') }}</div>
            </div>
            <div class="term-value" :class="{'error': checkup.isBosError}">
                {{ checkup.bos ? checkup.bos : '--' }}<span class="value-unit">%</span><span class="value-level"
                                                                        :class="{'is-en': $i18n.locale == 'en'}">{{ getBosLevel(checkup.bos) }}</span>
                <div class="term-char-box">
                    <div class="bos-char1"></div>
                    <div class="bos-char2"></div>
                    <div class="bos-char3"></div>
                    <img class="triangle" v-if="checkup.bos <= 70" style="left: 0"
                         src="@/assets/theme/light/status/23checkupDesc/10triangle.svg">
                    <img class="triangle" v-else-if="checkup.bos <= 89"
                         :style="{'left': ((checkup.bos) - 70) / 20 * 42 - 8 +'px'}"
                         src="@/assets/theme/light/status/23checkupDesc/10triangle.svg">
                    <img class="triangle" v-else-if="checkup.bos <= 94"
                         :style="{'left': ((checkup.bos) - 90) / 5 * 42 - 8 + 44+'px'}"
                         src="@/assets/theme/light/status/23checkupDesc/10triangle.svg">
                    <img class="triangle" v-else-if="checkup.bos <= 100"
                         :style="{'left': ((checkup.bos) - 95) / 5 * 42 - 8 + 88+'px'}"
                         src="@/assets/theme/light/status/23checkupDesc/10triangle.svg">
                </div>
            </div>
            <div class="term-desc">{{ $t('checkupDesc.bosDesc') }}</div>
        </div>
        <div class="term-item">
            <div class="term-item-top">
                <div class="term-item-top-left">
                    <img class="term-icon" src="@/assets/theme/light/status/23checkupDesc/06pressure.svg">
                    {{ $t('checkupDesc.pressure') }}
                </div>
            </div>
            <div class="term-value">
                {{ checkup.pressure ? checkup.pressure : '--' }}<span class="value-level">{{ getPressureLevel(checkup.pressure) }}</span>
                <div class="term-char-box">
                    <div class="pressure-char1"></div>
                    <div class="pressure-char2"></div>
                    <div class="pressure-char3"></div>
                    <div class="pressure-char4"></div>
                    <img class="triangle" v-if="checkup.pressure <= 29"
                         :style="{'left': checkup.pressure / 29 * 31 - 8 +'px'}"
                         src="@/assets/theme/light/status/23checkupDesc/10triangle.svg">
                    <img class="triangle" v-else-if="checkup.pressure <= 59"
                         :style="{'left': ((checkup.pressure) - 30) / 29 * 32 - 8 + 33 +'px'}"
                         src="@/assets/theme/light/status/23checkupDesc/10triangle.svg">
                    <img class="triangle" v-else-if="checkup.pressure <= 79"
                         :style="{'left': ((checkup.pressure) - 60) / 19 * 31 - 8 + 66+'px'}"
                         src="@/assets/theme/light/status/23checkupDesc/10triangle.svg">
                    <img class="triangle" v-else :style="{'left': ((checkup.pressure) - 80) / 19 * 31 - 8 + 99+'px'}"
                         src="@/assets/theme/light/status/23checkupDesc/10triangle.svg">
                </div>
            </div>
            <div class="term-desc">{{ $t('checkupDesc.pressureDesc') }}</div>
        </div>
        <div class="term-item">
            <div class="term-item-top">
                <div class="term-item-top-left">
                    <img class="term-icon" src="@/assets/theme/light/status/23checkupDesc/07temp.svg">
                    <span class="term-item-title">{{ $t('checkupDesc.temperature') }}</span>
                    <img v-if="checkup.isTemperatureError" src="@/assets/theme/light/status/23checkupDesc/11error.svg">
                </div>
                <div class="term-item-top-right"> {{ $t('checkupDesc.temperatureRefer') }}</div>
            </div>
            <div class="term-value" :class="{'error': checkup.isTemperatureError}">
                {{ checkup.isTemperatureError ? $t('checkupDesc.temperatureError') : checkup.temperature ? checkup.temperature : '--' }}<span
                class="value-unit"> ℃ </span><span class="value-unit">（{{ $t('checkupDesc.skin') }}</span>
                <span class="skin">{{ checkup.skinTemperature }}</span><span class="value-unit">℃）</span>
            </div>
            <div class="term-desc">{{ $t('checkupDesc.temperatureDesc') }}</div>
        </div>
        <div class="term-item">
            <div class="term-item-top">
                <div class="term-item-top-left">
                    <img class="term-icon" src="@/assets/theme/light/status/23checkupDesc/08rate.svg">
                    {{ $t('checkupDesc.rate') }}
                </div>
                <div class="term-item-top-right"> {{ $t('checkupDesc.rateRefer') }}</div>
            </div>
            <div class="term-value">
                {{ checkup.respiratoryRate ? checkup.respiratoryRate : '--' }}<span class="value-unit">{{ $t('checkupDesc.rateUnit') }}</span>
            </div>
            <div class="term-desc">{{ $t('checkupDesc.rateDesc') }}</div>
        </div>
        <div class="term-item" v-if="checkup.ecgData">
            <div class="term-item-top">
                <div class="term-item-top-left">
                    <img class="term-icon" src="@/assets/theme/light/status/23checkupDesc/09ecg.svg">
                    {{ $t('checkupDesc.ecg') }}
                </div>
                <div class="term-item-top-right black" @click="openDynamicDesc(checkup.ecgData)">
                    {{ $t('checkupDesc.ecgMore') }} >
                </div>
            </div>
            <div class="term-value" :class="{'error': checkup.isEcgError}">
                {{ checkup.ecgData ? checkup.ecgData.score : '--' }}<span
                class="value-unit">{{ $t('checkupDesc.ecgScore') }}</span><span class="value-level"
                                                                                :class="{'is-en': $i18n.locale == 'en'}">{{ checkup.ecgData ? getEcgLevel(checkup.ecgData.score): '--' }}</span>
                <div class="term-char-box ecg-char-box">
                    <div class="ecg-char1"></div>
                    <div class="ecg-char2"></div>
                    <div class="ecg-char3"></div>
                    <div class="ecg-char4"></div>
                    <div class="ecg-char5"></div>
                    <di v-if="checkup.ecgData">
                        <img class="triangle" v-if="checkup.ecgData.score <= 59"
                             :style="{'left': checkup.ecgData.score / 59 * 31 - 8 +'px'}"
                             src="@/assets/theme/light/status/23checkupDesc/10triangle.svg">
                        <img class="triangle" v-else-if="checkup.ecgData.score <= 79"
                             :style="{'left': ((checkup.ecgData.score) - 60) / 19 * 31 - 8 + 33 +'px'}"
                             src="@/assets/theme/light/status/23checkupDesc/10triangle.svg">
                        <img class="triangle" v-else-if="checkup.ecgData.score <= 89"
                             :style="{'left': ((checkup.ecgData.score) - 80) / 9 * 31 - 8 + 66+'px'}"
                             src="@/assets/theme/light/status/23checkupDesc/10triangle.svg">
                        <img class="triangle" v-else-if="checkup.ecgData.score <= 99"
                             :style="{'left': ((checkup.ecgData.score) - 90) / 9 * 31 - 8 + 99+'px'}"
                             src="@/assets/theme/light/status/23checkupDesc/10triangle.svg">
                        <img class="triangle" v-else style="left: 155px"
                             src="@/assets/theme/light/status/23checkupDesc/10triangle.svg">
                    </di>
                </div>
            </div>
            <div class="ecg-char" id="ecg-chart"></div>
            <div class="ecg-conclusion">{{ getConclude(checkup.ecgData.conclusion) }}</div>
            <div class="ecg-conclusion">{{ this.$t('hr.suggest.' + checkup.ecgData.suggest) }}</div>
            <div class="top-con-split"></div>
        </div>
        <div class="term-item">
            <div class="tips-title">{{ $t('checkupDesc.tips') }}</div>
            <div class="tips">{{ $t('checkupDesc.tipsText') }}</div>
        </div>
    </div>
</template>

<script>
import {WebJSBridge} from "../../utils/JSBridge1";
import VueMarkdown from "vue-markdown";
import {getSkin} from "../../utils/comment";

export default {
    name: '23checkupDesc',
    components: {VueMarkdown},
    data() {
        return {
            id: 0,
            checkup: {},
            ratio: 1,
            shareTag: 0,
            theme: 'light'
        }
    },
    mounted() {
        if (this.$route.query.theme) {
            this.theme = this.$route.query.theme
        }
        this.ratio = document.body.clientWidth / 375 ? document.body.clientWidth / 375 : 1;
        if (this.$route.query.id) {
            this.id = this.$route.query.id
            this.getUserCheckupDesc();
        }
    },
    methods: {
        share() {
            this.shareTag = 1;
            WebJSBridge.call("shareReport", null, function (res) {
                console.log("recieve callback")
                console.log(res)
            });
        },
        getUserCheckupDesc() {
            this.$api.status.getUserCheckupById({
                id: this.id
            }).then(res => {
                this.checkup = res.info
                this.dealData()
                if (this.checkup.ecgData) {
                    this.checkup.ecgData.score = Math.round(this.checkup.ecgData.score)
                    this.$nextTick(function () {
                        this.drawEcg(this.checkup.ecgData)
                    })
                }
            })
        },
        back() {
            this.$router.back()
        },
        dealData() {
            let errorCount = 0;
            if (this.checkup.isBosError) {
                errorCount++;
            }
            if (this.checkup.isEcgError) {
                errorCount++;
            }
            if (this.checkup.isHrError) {
                errorCount++;
            }
            if (this.checkup.isPressureError) {
                errorCount++;
            }
            if (this.checkup.isRespiratoryRateError) {
                errorCount++;
            }
            if (this.checkup.isTemperatureError) {
                errorCount++;
            }
            this.checkup.errorCount = errorCount;

            let success = 0;
            if (this.checkup.bos) {
                success++;
            }
            if (this.checkup.ecgId) {
                success++;
            }
            if (this.checkup.hr) {
                success++;
            }
            if (this.checkup.pressure) {
                success++;
            }
            if (this.checkup.respiratoryRate) {
                success++;
            }
            if (this.checkup.temperature) {
                success++;
            }
            this.checkup.success = success;
            this.checkup.normalCount = success - errorCount;
        },
        getBosLevel(num) {
            if (num >= 95) {
                return this.$t('checkupDesc.bosLevel0')
            } else if (num >= 90) {
                return this.$t('checkupDesc.bosLevel1')
            } else {
                return this.$t('checkupDesc.bosLevel2')
            }
        },
        getConclude(org) {
            if (org) {
                let orgArr = org.split('；');
                let newStr = '';
                if (orgArr.length > 1) {
                    for (let i = 0; i < orgArr.length; i++) {
                        let org = orgArr[i].substring(2, orgArr[i].length).replace(/\。/g, '');
                        let no = i + 1;
                        if (i == 0) {
                            newStr = no + '、' + this.$t('hr.conclude.' + org);
                        } else {
                            newStr = newStr + '\n' + no + '、' + this.$t('hr.conclude.' + org);
                        }
                    }
                }
                if (orgArr.length == 1) {
                    org = org.substring(0, org.length - 1);
                    newStr = this.$t('hr.conclude.' + org);
                }
                return newStr;
            }
        },
        getPressureLevel(num) {
            if (num >= 80) {
                return this.$t('checkupDesc.pressureLevel3')
            } else if (num >= 60) {
                return this.$t('checkupDesc.pressureLevel2')
            } else if (num >= 30) {
                return this.$t('checkupDesc.pressureLevel1')
            } else {
                return this.$t('checkupDesc.pressureLevel0')
            }
        },
        getEcgLevel(num) {
            if (num >= 100) {
                return this.$t('checkupDesc.ecgLevel0')
            } else if (num >= 90) {
                return this.$t('checkupDesc.ecgLevel1')
            } else if (num >= 80) {
                return this.$t('checkupDesc.ecgLevel2')
            } else if (num >= 60) {
                return this.$t('checkupDesc.ecgLevel3')
            } else {
                return this.$t('checkupDesc.ecgLevel4')
            }
        },
        drawEcg(item) {
            let a = item.ecgFragment;
            let b = a.split(',');
            let c = [];
            for (let i = 0; i < b.length; i++) {
                c.push(i);
            }
            let myChart = this.$echarts.init(document.getElementById('ecg-chart'));
            myChart.setOption({
                grid: {
                    top: 10 * this.ratio,
                    bottom: 10 * this.ratio,
                    left: 10 * this.ratio,
                    right: 10 * this.ratio
                },
                xAxis: {
                    type: 'category',
                    axisLine: {
                        show: false,
                    },
                    axisLabel: {
                        show: false
                    },
                    axisTick: {
                        show: false
                    },
                    splitLine: {
                        show: false
                    },
                    data: c
                },
                yAxis: {
                    type: 'value',
                    position: 'right',
                    axisLabel: {
                        show: false
                    },
                    splitLine: {
                        show: false
                    }
                },
                series: [
                    {
                        data: b,
                        type: 'line',
                        symbol: 'none',
                        color: getSkin('--chart-color-3'),
                        smooth: false,
                        lineStyle: {
                            width: 2
                        }
                    }
                ]
            }, true);
        },
        openDynamicDesc(item) {
            WebJSBridge.call("openDynamicDesc", {
                ecgId: item.id,
                sportId: item.sportId,
                sportType: item.sportType,
                userAvatar: item.userAvatar,
                startSportTime: item.createTime
            }, function (res) {
                console.log("recieve callback")
                console.log(res)
            });
        },
        toAI() {
            this.$router.push({
                name: 'checkupDeepSeek',
                query: {
                    lang: this.$i18n.locale,
                    id: this.checkup.id,
                    type: 0,
                    theme: this.theme
                }
            })
        }
    }
}
</script>

<style scoped>

.content {
    color: var(--text-color-1);
    padding-top: 0;
}

.top-box {
    width: 375px;
    position: relative;
}

.bg {
    width: 375px;
    position: absolute;
    top: 0;
    left: 0;
    z-index: -1;
}

.share-icon {
    float: right;
}

.banner {
    background-color: transparent;
}

.device {
    font-size: 13px;
    color: var(--text-color-2);
    position: absolute;
    left: 36px;
    top: 98px;
}

.check-time {
    font-size: 13px;
    color: var(--text-color-2);
    position: absolute;
    left: 36px;
    top: 118px;
}

.top-con-box {
    width: 345px;
    background: var(--bg-color-2);
    border-radius: 10px 10px 10px 10px;
    margin: 60px auto 0;
}

.top-con-title {
    font-size: 17px;
    padding-top: 13px;
    margin-left: 21px;
}

.top-con-sub {
    font-size: 13px;
    color: var(--text-color-2);
    margin-left: 21px;
    margin-top: 8px;
}

.sub-normal {
    color: var(--chart-color-24);
}

.top-con-split {
    width: 345px;
    height: 13px;
}

.top-con-error {
    margin-left: 21px;
    margin-top: 8px;
    display: flex;
    align-items: center;
    color: var(--chart-color-3);
    font-size: 13px;
}

.error-box {
    background: var(--chart-color-4);
    border-radius: 3px 3px 3px 3px;
    font-size: 9px;
    color: var(--chart-color-3);
    padding: 3px 8px;
    display: inline-block;
}

.top-con-error-desc {
    margin-left: 5px;
    width: 280px;
    line-height: 16px;
}

.ai-img {
    width: 345px;
    margin: 10px 15px 0px;
}

.term-title {
    font-size: 15px;
    color: var(--text-color-1);
    margin-left: 15px;
    margin-bottom: 12px;
    margin-top: 10px;
}

.term-item {
    width: 345px;
    background: var(--bg-color-2);
    border-radius: 13px 13px 13px 13px;
    margin: 10px auto;
}

.term-item-top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-top: 12px;
}

.term-item-top-left {
    display: flex;
    align-items: center;
    font-size: 15px;
    letter-spacing: 2px;
}

.term-icon {
    width: 16px;
    margin-left: 12px;
    margin-right: 5px;
}

.term-item-top-right {
    font-size: 13px;
    color: var(--text-color-2);
    margin-right: 16px;
    text-align: right;
    margin-left: 20px;
}

.term-value {
    font-size: 27px;
    margin-top: 4px;
    margin-left: 37px;
}

.value-unit {
    font-size: 13px;
    color: var(--text-color-2);
    margin-left: 4px;
}

.term-desc {
    font-size: 13px;
    color: var(--text-color-2);
    line-height: 18px;
    margin: 5px 16px 0 37px;
    padding-bottom: 12px;
    letter-spacing: 0.5px;
}

.term-item-title {
    margin-right: 8px;
}

.value-level {
    font-size: 12px;
    margin-left: 10px;
}

.error {
    color: var(--chart-color-3) !important;
}

.term-value.error .value-unit {
    color: inherit !important;
}

.term-char-box {
    width: 131px;
    height: 15px;
    float: right;
    margin-right: 16px;
    margin-top: 10px;
    position: relative;
}

.bos-char1 {
    width: 42px;
    height: 10px;
    background: var(--chart-color-10);
    border-radius: 5px 0px 0px 5px;
    position: absolute;
    top: 0;
    left: 0;
}

.bos-char2 {
    width: 42px;
    height: 10px;
    background: var(--chart-color-5);
    border-radius: 0px 0px 0px 0px;
    position: absolute;
    top: 0;
    left: 45px;
}

.bos-char3 {
    width: 42px;
    height: 10px;
    background: var(--chart-color-3);
    border-radius: 0px 5px 5px 0px;
    position: absolute;
    top: 0;
    right: 0;
}

.triangle {
    width: 16px;
    position: absolute;
    top: 6px;
    left: 0;
}

.pressure-char1 {
    width: 31px;
    height: 10px;
    background: var(--chart-color-24);
    border-radius: 5px 0px 0px 5px;
    position: absolute;
    top: 0;
    left: 0;
}


.pressure-char2 {
    width: 31px;
    height: 10px;
    background: var(--chart-color-8);
    border-radius: 0px 0px 0px 0px;
    position: absolute;
    top: 0;
    left: 33px;
}


.pressure-char3 {
    width: 31px;
    height: 10px;
    background: var(--chart-color-5);
    border-radius: 0px 0px 0px 0px;
    position: absolute;
    top: 0;
    left: 66px;
}


.pressure-char4 {
    width: 31px;
    height: 10px;
    background: var(--chart-color-3);
    border-radius: 0px 5px 5px 0px;
    position: absolute;
    top: 0;
    right: 0;
}

.skin {
    font-size: 12px;
}

.ecg-char-box {
    width: 164px;
}

.ecg-char1 {
    width: 31px;
    height: 10px;
    background: var(--chart-color-3);
    border-radius: 5px 0px 0px 5px;
    position: absolute;
    top: 0;
    left: 0;
}

.ecg-char2 {
    width: 31px;
    height: 10px;
    background: var(--chart-color-5);
    border-radius: 0px 0px 0px 0px;
    position: absolute;
    top: 0;
    left: 33px;
}

.ecg-char3 {
    width: 31px;
    height: 10px;
    background: var(--chart-color-15);
    border-radius: 0px 0px 0px 0px;
    position: absolute;
    top: 0;
    left: 66px;
}

.ecg-char4 {
    width: 31px;
    height: 10px;
    background: var(--chart-color-1);
    border-radius: 0px 0px 0px 0px;
    position: absolute;
    top: 0;
    left: 99px;
}

.ecg-char5 {
    width: 31px;
    height: 10px;
    background: var(--chart-color-8);
    border-radius: 0px 5px 5px 0px;
    position: absolute;
    top: 0;
    right: 0;
}

.ecg-char {
    width: 293px;
    height: 92px;
    background: var(--bg-color-2);
    border-radius: 0px 0px 0px 0px;
    border: 1px solid var(--line-color-2);
    margin-left: 37px;
    margin-bottom: 13px;
}

.ecg-conclusion {
    font-size: 10px;
    color: var(--text-color-1);
    line-height: 15px;
    margin: 0 16px 0 37px;
}

.black {
    color: var(--text-color-1);
}

.tips-title {
    font-size: 15px;
    padding: 14px 0 13px 16px;
    letter-spacing: 2px;
}

.tips {
    font-size: 13px;
    color: var(--text-color-2);
    line-height: 18px;
    padding: 0 16px 15px 16px;
    letter-spacing: 0.5px;
}

.is-en {
    font-size: 12px;
}

.ai-box {
    font-size: 13px;
    line-height: 20px;
    padding: 0 16px 15px 16px;
    letter-spacing: 0.5px;
}

.hidden {
    visibility: hidden;
}
</style>


// WEBPACK FOOTER //
// src/views/status/23checkupDesc.vue